class FavoritesDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.sidebarDrawer = new Drawer(this.element);
    this.delegateBody = new Delegate(document.body);
   
    this.loader = this.element.querySelector(".loader");
    this.cartCount = document.querySelector(".FavoritesCount");
    this.pageOverlayElement = document.querySelector(".favOverlay");
    this.toggleFavorites();
    this.favoritesNumber();
    this.bindEvents();
  }
  unbindEvents(){
      document.removeEventListener('favorite-product:open', this.onFavoritesOpenListener);
      document.removeEventListener(
      'click',
          this._addToFavoritesL
      );
      document.removeEventListener('keydown', this.handleKeyDown);

  }
  bindEvents(){
      
      if(!document.body.classList.contains('listener')){
        this.onFavoritesOpenListener = this.onFavoritesOpen.bind(this);
        this._addToFavoritesL =  this.addToFavorites.bind(this);
        this.delegateBody.on('click', '[data-action="toggle-favorites"]', this._addToFavoritesL);
        document.body.classList.add('listener');
        document.addEventListener('favorite-product:open', this.onFavoritesOpenListener);
        this.delegateElement.on(
            "click",
            '[data-action="create-drawer"]',
            this.createDrawer.bind(this)
        );
        this.delegateBody.on(
            "click",
            '[data-action="close-sizedrawer"]',
            this.closeDrawer.bind(this)
        );
        document.addEventListener('scroll', this.scrollListener)
        document.addEventListener('keydown', this.handleKeyDown);
      }
  }

  handleKeyDown(event) {
    // Aktiviraj klik kad se pritisne Enter ili Space na elementima koji su "button" po ARIA
    if (
      (event.key === 'Enter' || event.key === ' ') &&
      event.target.getAttribute('role') === 'button'
    ) {
      event.preventDefault();
      event.target.click();
    }
  }


  scrollListener(){
    if (document.body.scrollTop > 36 || document.documentElement.scrollTop > 36) {
      document.documentElement.style.setProperty('--announcement-height', 0+"px");
    } else {
      document.documentElement.style.setProperty('--announcement-height', document.querySelector('.announcement-bar').offsetHeight+"px");
    }
  }

  favoritesNumber() {
    var items = JSON.parse(localStorage.getItem('productFavorites') || '[]');
    var realitems = items.filter(function (e) {return e != "";});
    var len= realitems.length;

    if (len > 0){
      let number = document.querySelector('.FavoritesCount');
      number.innerHTML = len;
    }else{
    }
  }

  createDrawer(event, target) {
    const toggleID = event.target.getAttribute('data-toggle-id');
    let subdrawer = this.element.querySelector('#' + toggleID);
    trapFocus(subdrawer);

    if (subdrawer && subdrawer.getAttribute('aria-expanded') == "false") {
        // Resetuj select na default vrednost
        $(subdrawer).find('.product-variants').prop('selectedIndex', 0);
        subdrawer.style.display = "block";
        subdrawer.setAttribute('aria-expanded', "true");
        this.pageOverlayElement.classList.add("is-visible");
        this.onClickOutsideListener = this.closeDrawer.bind(this);
        this.pageOverlayElement.addEventListener("click", this.onClickOutsideListener);

        var variantNumber = $(subdrawer).find('.product-variants option');
        var variantOptions = $(subdrawer).find('.product-variants');

        if (variantNumber.length > 1) {
            subdrawer.querySelector('.atcBUTTON').setAttribute('data-action', 'openSize');
            subdrawer.querySelector('.atcBUTTON').removeAttribute('data-add-to-cart');
            subdrawer.querySelector('.atcBUTTON').removeAttribute('disabled');

            $(subdrawer).find("[data-action='openSize']").on("click", function(event) {
                event.preventDefault();
                if ($.trim($(subdrawer).find('.atcBUTTON > span').text()) != "COMING SOON") {
                    $(subdrawer).find('.atcBUTTON > span').html("PLEASE SELECT SIZE");
                }
            });

            variantOptions.on('change', function() {
                var selectedOption = $(this).find(":selected");
                var variant = selectedOption.attr("data-value");
                var variantId = selectedOption.attr("variant-id");
                if (variant != undefined) {
                    subdrawer.querySelector('.atcBUTTON').removeAttribute('data-action', 'openSize');
                    subdrawer.querySelector('.atcBUTTON').setAttribute('data-add-to-cart', 'true');
                    subdrawer.querySelector('.atcBUTTON').classList.remove('notifyOpen');
                    subdrawer.querySelector('.atcBUTTON > span').innerHTML = "ADD TO CART";
                    subdrawer.querySelector('.atcBUTTON').classList.add('js-add-cart3');
                    subdrawer.querySelector('.atcBUTTON').setAttribute('data-add-to-cart', 'true');
                    subdrawer.querySelector('.atcBUTTON').setAttribute('data-value', variant);
                    subdrawer.querySelector('.atcBUTTON').setAttribute('variant-id', variantId);
                } else {
                    subdrawer.querySelector('.atcBUTTON').classList.add('notifyOpen');
                    subdrawer.querySelector('.atcBUTTON > span').innerHTML = "NOTIFY ME";
                    subdrawer.querySelector('.atcBUTTON').classList.remove('js-add-cart3');
                    subdrawer.querySelector('.atcBUTTON').removeAttribute('data-action', 'openSize');
                    subdrawer.querySelector('.atcBUTTON').removeAttribute('data-add-to-cart', 'true');
                    subdrawer.querySelector('.atcBUTTON').setAttribute('data-action', 'open-bis');
                    subdrawer.querySelector('.atcBUTTON').removeAttribute('data-value', variant);
                    subdrawer.querySelector('.atcBUTTON').setAttribute('variant-id', variantId);
                }
            });

        } else {
            let option = subdrawer.querySelector('.product-variants option');
            let variant = option.getAttribute('value');
            let available = option.getAttribute('data-available') === 'true';
            var variantId = option.getAttribute('variant-id');

            if (available) {
                option.selected = true;
                subdrawer.querySelector('.atcBUTTON').classList.add('js-add-cart3');
                subdrawer.querySelector('.atcBUTTON > span').innerHTML = "ADD TO CART";
                subdrawer.querySelector('.atcBUTTON').setAttribute('data-add-to-cart', 'true');
                subdrawer.querySelector('.atcBUTTON').setAttribute('data-value', variant);
                subdrawer.querySelector('.atcBUTTON').setAttribute('variant-id', variantId);
            } else {
                subdrawer.querySelector('.atcBUTTON').classList.add('notifyOpen');
                subdrawer.querySelector('.atcBUTTON > span').innerHTML = "NOTIFY ME";
                subdrawer.querySelector('.atcBUTTON').classList.remove('js-add-cart3');
                subdrawer.querySelector('.atcBUTTON').removeAttribute('data-add-to-cart');
                subdrawer.querySelector('.atcBUTTON').setAttribute('data-action', 'open-bis');
                subdrawer.querySelector('.atcBUTTON').setAttribute('data-value', variant);
            }
        }
    }
}

  closeDrawer() {
      const toggleId = document.querySelectorAll('.sizeDrawer_Wrapper');
      toggleId.forEach((id)=> {
        id.style.display="none";
        id.setAttribute("aria-expanded", "false");
        $(id).find('.product-variants').prop('selectedIndex', 0);
      })
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener("click", this.onClickOutsideListener);

       removeTrapFocus();
      //$('.sizeDrawer select').val('0');
  }


  onFavoritesOpen() {  
    var _this = this;
    _this.rerenderFavorites();
    _this.sidebarDrawer.isOpen = true;
    document.documentElement.classList.add('noScroll');
  }


  getSearchQueryStrings() {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    // If we are on a product template, we make sure to remove the main product from the related product
    const bucketSize = 10.0;
    const idBuckets = [];
    items.forEach((id, index) => {
      const key = Math.floor(index / bucketSize);
      if (!idBuckets[key]) {
        idBuckets[key] = [];
      }
      idBuckets[key].push(id);
    });
    return idBuckets.reduce((acc, vall) => {
      const string = vall
        .map(function (id) {
          return "id:" + id;
        })
        .join(" OR ");

      acc.push(string);
      return acc;
    }, []);
  }

  rerenderFavorites(event) {
    this.loader.classList.add("is-visible");
    this.element.querySelector('.favoritesItems').style.display = 'none';
    var _this = this;
    var queryStrings = this.getSearchQueryStrings();
    const promises = [];
    if (queryStrings.length == 0) {
      this.loader.classList.remove("is-visible");
      fetch("/?section_id=favorites-drawer").then(function (content) {
        content.text().then(function (html) {
          _this.replaceContentFav(html);
          _this.loader.classList.remove("is-visible");
         
        });
      });

    }
    queryStrings.forEach((string) => {
      promises.push(
        fetch(window.routes.localeRootUrl + "/search?view=favorites&type=product&q=" + string, {
          credentials: "same-origin",
          method: "GET",
        })
      );
    });
    promises.reduce(async (acc, val, index) => {
      const content = await val.then((response) => response.text());
      const container = this.element;
      if (!container.length) {
        _this.replaceContentFav(content);
        _this.loader.classList.remove("is-visible");
      } else {
        this.loader.classList.remove("is-visible");
      }
    }, Promise.resolve());

    return Promise.resolve();
  }

  replaceContentFav(html) {
    var tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    var number = tempElement
      .querySelector(".countFav")
      .getAttribute("data-count");
      var favCount = document.querySelector('.FavoritesCount');
      favCount.innerHTML = number;
    var cartNodeParent = this.element.querySelector(".favourites-drawer__inner-wrapper");
    cartNodeParent.replaceChild(
      tempElement.querySelector("#cartData"),
      this.element.querySelector("#cartData")
    );
    this.toggleFavorites();
    
    this.loader.classList.remove("is-visible");
    this.element.querySelector('.favoritesItems').style.display = 'block';

    const drawerContent = this.element.querySelector('.favourites-drawer__inner-wrapper');
    trapFocus(drawerContent);
    
    return true;
  }

  toggleFavorites() {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    var favorites = document.querySelectorAll(".ProductCard--Favorites");

    favorites.forEach(function (item) {
      var state = item.getAttribute("state");
      var myID = item.getAttribute("data-id");

      if (state == "not-active" && items.includes(myID)) {
        item.querySelector(".brokenHearth").style.display = "flex";
        item.querySelector(".emptyHearth").style.display = "none";
        item.setAttribute("state", "active");
      } else if (!items.includes(myID)) {
        item.querySelector(".brokenHearth").style.display = "none";
        item.querySelector(".emptyHearth").style.display = "flex";
        item.setAttribute("state", "not-active");
      }
    });
    
  }

  removeFromFavorites(productId) {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    items = items.filter((c) => c != productId);

    try {
      localStorage.setItem(
        "productFavorites",
        JSON.stringify(items.slice(0, 50))
      );
    } catch (error) {
      console.log(error);
    }
    this.toggleFavorites();
    this.rerenderFavorites();
  }

  addToFavorites(event, target) {
    event.preventDefault();

    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    var productId = target.getAttribute("data-id");
console.log(productId)
    // We check if the current product already exists, and if it does not, we add it at the start
    if (!items.includes(productId) && productId != "") {
      items.unshift(productId);
    } else {
      this.removeFromFavorites(productId, false);
      
      return;
    }
    // Then, we save the current product into the local storage, by keeping only the 50 most recent
    try {
      localStorage.setItem(
        "productFavorites",
        JSON.stringify(items.slice(0, 50))
      );
     
      this.toggleFavorites();
      if (this.sidebarDrawer.isOpen == true) {
    this.rerenderFavorites()
    }
    } catch (error) {
      // Do nothing, this may happen in Safari in incognito mode
    }
    
    this.rerenderFavorites();
  }
}
customElements.define("favorites-drawer", FavoritesDrawer);

class FavoritesPage extends HTMLElement {
  constructor() {
      super();
      this.element = this;
      this.pageOverlayElement = document.querySelector(".fav-pageOverlay");
      this.delegateElement = new Delegate(this.element);
      this.delegateBody = new Delegate(document.body);
      this.bindEvents();
      
      this.rerenderFavorites();
      this.favoritesNumber();
     
  }

  bindEvents() {
    this.delegateElement.on('click', '[data-action="toggle-favorites"]', this.removeFromFavorites.bind(this));
    this.delegateElement.on('click', '[data-action="remove-all"]', this.removeAllFavorites.bind(this));
    this.delegateElement.on(
      "click",
      '[data-action="create-drawer"]',
      this.createDrawer.bind(this)
    );
    this.delegateBody.on(
        "click",
        '[data-action="close-drawer"]',
        this.closeDrawer.bind(this)
    );          
  }

  favoritesNumber() {
    var items = JSON.parse(localStorage.getItem('productFavorites') || '[]');
    var realitems = items.filter(function (e) {return e != "";});
    var len= realitems.length;

    if (len > 0){
      let number = document.querySelector('.FavoritesCount');
      number.innerHTML = len;
    }else{
    }
  }

  createDrawer(event, target){
    const toggleID = event.target.getAttribute('data-toggle-id');
        let subdrawer = this.element.querySelector('#'+toggleID);
        if(subdrawer && subdrawer.getAttribute('aria-expanded') == "false" ){
            subdrawer.style.display="block";
            subdrawer.setAttribute('aria-expanded', "true");
            this.pageOverlayElement.classList.add("is-visible");
            this.onClickOutsideListener = this.closeDrawer.bind(this);
            this.pageOverlayElement.addEventListener("click", this.onClickOutsideListener);            

        }
                        
    }

    closeDrawer() {
      const toggleId = document.querySelectorAll('.sizeDrawer_Wrapper');
      toggleId.forEach((id)=> {
        id.style.display="none";
        id.setAttribute("aria-expanded", "false");
      })
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener("click", this.onClickOutsideListener);
    }

  getSearchQueryStrings() {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    // If we are on a product template, we make sure to remove the main product from the related product
    const bucketSize = 10.0;
    const idBuckets = [];
    items.forEach((id, index) => {
      const key = Math.floor(index / bucketSize);
      if (!idBuckets[key]) {
        idBuckets[key] = [];
      }
      idBuckets[key].push(id);
    });
    return idBuckets.reduce((acc, vall) => {
      const string = vall
        .map(function (id) {
          return "id:" + id;
        })
        .join(" OR ");

      acc.push(string);
      return acc;
    }, []);
  }

       
  rerenderFavorites(){

    var _this32 = this;
    var queryStrings = this.getSearchQueryStrings();
    const promises = [];
    if(queryStrings.length > 0){
    queryStrings.forEach(string => {

      promises.push(
        fetch(window.routes.localeRootUrl + '/search?view=favourites-page&type=product&q=' + string, {
          credentials: 'same-origin',
          method: 'GET'
        }))
    })

      promises.reduce(async (acc, val, index) => {

        const content = await val.then(response => response.text())
        const container = $(_this32.element).find('.favoritesItems--grid');

        if (!container.length) {
          
          _this32.replaceContent(content);
          _this32.toggleFavorites();
          _this32.favoritesNumber();

        } else {
          const containerContent = $(content).find('.favoritesItems--grid').html();
          container.append(containerContent);
          _this32.toggleFavorites();
          _this32.favoritesNumber();
        }

      }, Promise.resolve());

      return Promise.resolve();
    } else {
      this.querySelector('.FavoritesEmpty').style.display = "block";
    }
  }

  replaceContent(html) {
    var tempElement = document.createElement('div');
    console.log(tempElement)
    tempElement.innerHTML = html;
   
    var cartNodeParent = this.element.querySelector('.FavoritesGrid').parentNode;
    cartNodeParent.replaceChild(tempElement.querySelector('.FavoritesGrid'), this.element.querySelector('.FavoritesGrid'));
     this.element.querySelector('.Favorites--textWrapper').style.display='block';
    return true;
  }

  toggleFavorites() {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    var favorites = document.querySelectorAll(".ProductCard--Favorites");

    favorites.forEach(function (item) {
      var state = item.getAttribute("state");
      var myID = item.getAttribute("data-id");

      if (state == "not-active" && items.includes(myID)) {
        item.querySelector(".brokenHearth").style.display = "flex";
        item.querySelector(".emptyHearth").style.display = "none";
        item.setAttribute("state", "active");
      } else if (!items.includes(myID)) {
        item.querySelector(".brokenHearth").style.display = "none";
        item.querySelector(".emptyHearth").style.display = "flex";
        item.setAttribute("state", "not-active");
      }
    });
    
  }   

  removeFromFavorites(productId) {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    items = items.filter((c) => c != productId);

    try {
      localStorage.setItem(
        "productFavorites",
        JSON.stringify(items.slice(0, 50))
      );
    } catch (error) {
      console.log(error);
    }
    var _this = this;
    _this.toggleFavorites();
    _this.rerenderFavorites();
    location.reload();
  }

  removeAllFavorites(){
    localStorage.setItem("productFavorites", '');
    location.reload();
  }
  
  
}
customElements.define("favorites-page", FavoritesPage);


class NotifyMe extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.initVariables();
    this.bindEvents();
  }

  initVariables() {
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    this.checkmarkSvg = 
      `<svg class="Svg Svg--checkmark mr-sl" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 21 20" fill="none">
        <path d="M8.12213 15.3833L2.32768 9.59442C2.13892 9.37399 2.15161 9.04542 2.35681 8.84021C2.56202 8.63501 2.89059 8.62232 3.11101 8.81108L8.11101 13.8111L17.8832 4.04997C18.1037 3.86121 18.4322 3.8739 18.6374 4.0791C18.8426 4.28431 18.8553 4.61288 18.6666 4.8333L8.12213 15.3833Z" fill="white"/>
      </svg>`
  }

  /**
   * Binds necessary events to elements.
   */
  bindEvents() {
    this.delegateBody.on("click", '[data-action="open-bis"]', this.openNotifyMe.bind(this));
    this.delegateBody.on("click", '[data-action="triger-bis"]', this.handleSubscribe.bind(this));
    this.delegateElement.on("click", '[data-action="close-modal"]', this.closeModal.bind(this));

    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  /**
   * Handles the subscription process.
   */
  handleSubscribe() {
    const email = this.element.querySelector('[name="bis_mail"]').value;
    SI.Config.product = undefined;
    let promise = SI.create(email, this.variantId, this.productId);
  
    if(email !== '' && email.includes('@')){
      promise.then((st, data) => {
        let resp = SI.parseJSON(data);
        if (resp.status == "OK") {
          this.showSuccessState();
        }
      })
    }
  }

  /**
   * Shows a success message upon successful subscription.
   */
  showSuccessState() {
    this.element.querySelector('.preSuccessText').style.display = "none";
    this.element.querySelector('.successText').setAttribute('aria-hidden', 'false');
    this.emailInput = this.element.querySelector(".bis_input");
    this.emailInput.style.display = "none";

    this.updateButtonState();
  }

  /* updates submit button to successful state */
  updateButtonState() {
    const button = this.element.querySelector('.NewsletterPopupSubmit');
    const buttonTextElem = button.querySelector(".button--text");
     
    button.setAttribute('data-action', 'close-modal');
    button.innerHTML = "OK";
    button.style.margin = '0 auto';
  }

  /**
   * Opens the NotifyMe modal.
   * @param {Event} event - The event object.
   */
  openNotifyMe(event) {
    event.preventDefault();
      
    const target = event.target.closest('[data-action="open-bis"]');
    console.log(target)
    if (!target) {
      console.log("Target not found!");
      return;
    }

    this.successTextButton = target.closest("[data-success-form-text]");
      
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById('bis_popup');
    this.productId = target.getAttribute('product-id');
    this.variantId = target.getAttribute('variant-id');
    console.log(this.productId, this.variantId)
    this.activeModal.setAttribute("aria-hidden", "false");
    this.activeModal.style.display = "block";
    this.pageOverlayElement.addEventListener("click", this.onClickOutsideListener);

   
   const input = this.querySelector('.bis_input');
   const buttonSubmit = this.querySelector('.NewsletterPopupSubmit');
   
    input.addEventListener("input", (event)=> {
      
      let inputValue = event.target.value;
      if(inputValue.includes('@') && inputValue != ''){
        buttonSubmit.setAttribute("enabled", "");
      }else{
        buttonSubmit.removeAttribute("enabled");
      }
    });

  
  }

  /**
   * Closes the NotifyMe modal.
   */
  closeModal() {
    this.activeModal = document.body.querySelector('#bis_popup');
    this.activeModal.setAttribute("aria-hidden", "true");

    this.activeModal.removeAttribute("style");

    setTimeout(() => {
      this.emailInput.style.display = "none";
      this.defaultSubmitButtonState();
    }, 200)
  }

  /* after you submit your email button state turns to "ok" and it closes popup */ 
  /* sets submit buttons state back to normal after the popup has been closed */
  defaultSubmitButtonState() {
    const button = this.element.querySelector('.NewsletterPopupSubmit[data-action="close-modal"]');
    if (!button || !this.buttonText) return;

    const action = "triger-bis";
    button.dataset.action = action;
  }
}

customElements.define("bis-popup", NotifyMe);